export const llmAnalyticsFeatures = {
    summary: {
        name: 'LLM Analytics',
        description: 'Monitor and debug your LLM-powered features',
        url: '/llm-analytics',
        docsUrl: '/docs/llm-analytics',
    },
    features: {
        generation_tracking: {
            name: 'Generation tracking',
            description: 'Track the generation of your LLM-powered features',
        },
        latency_tracking: {
            name: 'Latency tracking',
            description: '',
        },
        cost_tracking: {
            name: 'Cost tracking',
            description: 'Includes cost per user',
        },
        trace_visualization: {
            name: 'Trace visualization',
            description: '',
        },
        token_tracking: {
            name: 'Token tracking',
            description: '',
        },
        prompt_playground: {
            name: 'Prompt playground',
            description: '',
        },
        prompt_evaluations: {
            name: 'Prompt evaluations',
            description: '',
        },
        alerting: {
            name: 'Alerting',
            description: '',
        },
    },
}
